export default [
  {
    title: 'Mode',
    type: 'text',
    data: '',
    required: true,
    initialValue: '',
    note_text: '',
    additional: '',
    dataIndex: 'mode',
    order: 2,
  }, {
    title: 'Merchant group',
    type: 'SelectQuery',
    data: 'merchantGroups',
    required: true,
    initialValue: '',
    note_text: '',
    selectedKey: 'pk',
    selectedValue: 'name',
    additional: 'edit|add',
    dataIndex: 'merchant_group',
    order: 0,
  }, {
    title: 'Merchant',
    type: 'SelectQuery',
    // required: true,
    data: 'merchants',
    initialValue: '',
    note_text: '',
    selectedKey: 'pk',
    selectedValue: 'name',
    additional: 'edit|add',
    dataIndex: 'merchant',
    order: 1,
    isActive: true, // for SelectQuery Autocomplete
  },
];